<div class="p-0 lh-sm">
    {{ timerCount() | formatDuration }}
</div>
